import ApiService from './api-service';

export default ApiService;
